import React from 'react';
import { useSelector } from 'react-redux';
import { BarLoader } from 'react-spinners';
import { styled } from 'styled-components';
import { Heading } from '../../_atoms/Heading';
import { Paragraph } from '../../_atoms/Paragraph';
import { ImageButton } from '../../_molecules/ImageButton';
import { ResourcesButton } from '../../_molecules/ResourcesButton';

const Wrap = styled.div`
  width: 100%;
  overflow: hidden;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

const Loader = styled(BarLoader)`
  position: absolute;
  bottom: 30%;
  z-index: 1;
`;

export const ResourcesWrap = () => {
  const state = useSelector((state) => state);
  
  return (
    <>
      <ImageButton
        type="home"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/btn_home_150px.png"
        alt="HOME"
        onClick={() => window.location.hash="#/"}
      />
      <ImageButton
        type="back"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/btn_pre_150px.png"
        alt="BACK"
        onClick={() => window.location.hash="#/menu/" + (state.book.current_book + 1)}
      />
      
      <Wrap>
        <Heading level={1} type="resource">
          Learning Resources
        </Heading>

        <Paragraph type="resource">Click the icon and open the file you want.</Paragraph>

        <ResourcesButton />
      </Wrap>
      
      {state.common.loading && (
        <Loader
          color="#5493fc"
          height={12}
          speedMultiplier={0.8}
          width={800}
        />  
      )}
    </>
  );
};